<template>
  <div class="js-basedata-cargroup app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="6">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="
                $t('baseData.terminalmanage.terminalInfo.searchWidth.width1')
              "
            >
              <el-form-item
                :label="$t('public.obdCode') + '：'"
              >
                <el-input
                  v-model="listQuery.barCode"
                  filterable
                  clearable
                  :placeholder="$t('public.obdCode')"
                />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="
                $t('baseData.terminalmanage.terminalInfo.searchWidth.width2')
              "
            >
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter = true"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      size="mini"
      v-loading="listLoading"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @current-change="handleCurrentRowChange"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{
            scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div v-if="item.prop == 'changeUp' || item.prop == 'timedUp'">
            <span>
              {{
                scope.row[item.prop] === 0
                  ? $t("public.close")
                  : !scope.row[item.prop]
                  ? "/"
                  : `${$t("public.startUp")} (${scope.row[item.prop]})`
              }}
            </span>
          </div>
          <div
            v-else-if="
              item.prop === 'threeAixWakeupValue' ||
              item.prop === 'drivingBoard' ||
              item.prop === 'ontimeWakeupDelayValue'
            "
          >
            <span>{{
              scope.row[item.prop] === 0
                ? $t("public.close")
                : scope.row[item.prop] > 0
                ? $t("public.opens")
                : "/"
            }}</span>
          </div>
          <div v-else>
            {{
              scope.row[item.prop] ||
              (scope.row[item.prop] === 0 ? scope.row[item.prop] : "/")
            }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total > 0 ? 'visible' : 'hidden', 'pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    
    <add-update-dialog
          :visibles.sync="addUpdateVisible"
          :is-edit="isEdit"
          :data="isEdit ? currentRow : {}"
          @add-complete="addComplete"
          @update-complete="updateComplete"
    />
  </div>
</template>

<script>
// 混入
import { partialForm } from "@/mixins/partialForm"
import { pagingMixin } from "@/mixins/table"
import { otherHeight } from "@/mixins/getOtherHeight"
import { tableStyle } from "@/mixins/tableStyle"
import { getPageButton } from "@/mixins/getButton"
//组件
import addUpdateDialog from "./components/addUpdateDialog"

// request
import {
  getTerminalConfigList,
  deleteTermianlConfig,
} from "@/api/obdDevice/obdConfig"
export default {
  name: "terminalConfig",
  components: { addUpdateDialog },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      listQuery: {},
      importDataConifg: {},
      showfilter: false,
      tableList: [
        // { value: this.$t('baseData.terminalConfig.terminalId'), prop: 'terminalId', position: 'center', width: 240, checked: true },
        {
          value: this.$t("public.obdCode"),
          prop: "barCode",
          position: "center",
          width: "120",
          checked: true,
        },
        {
          value: this.$t("carManagement.vinno"),
          prop: "responseVin",
          position: "center",
          width: "120",
          checked: true,
        },
        {
          value: this.$t("baseData.terminalConfig.responseVid"),
          prop: "responseVid",
          position: "center",
          width: "120",
          checked: true,
        },
        {
          value: this.$t("baseData.terminalConfig.responseYear"),
          prop: "responseYear",
          position: "center",
          width: "120",
          checked: true,
        },
        {
          value: this.$t("baseData.terminalConfig.responseDisplacement"),
          prop: "responseDisplacement",
          position: "center",
          width: "120",
          checked: true,
        },
        {
          value: this.$t("baseData.terminalConfig.responseInit"),
          prop: "responseInit",
          position: "center",
          width: "120",
          checked: true,
        },
        {
          value: this.$t("baseData.terminalConfig.configName"),
          prop: "configName",
          position: "center",
          width: "120",
          checked: true,
        },
        {
          value: this.$t("baseData.terminalConfig.terminalCode"),
          prop: "terminalCode",
          position: "center",
          width: "120",
          checked: true,
        },
      ],
      authouizeList: [],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      isEdit: false,
      addUpdateVisible: false,
      currentRow: null,
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter((item) => item.checked)
    },
  },
  methods: {
    // 加载数据
    listLoad() {
      this.listLoading = true
      getTerminalConfigList(this.listQuery)
        .then(({ data }) => {
          this.list = []
          if (data.code === 0) {
            this.list = data.data
            this.total = data.total
            const orderSort = "barCode"
            this.setOrderField(orderSort, this.tableList)
          }
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 检测是否未选择
     */
    checkCurrentRowEmpty() {
      return !this.currentRow
    },
    handleCurrentRowChange(val) {
      this.currentRow = val
    },
    //新增
    handleAdd() {
      this.isEdit = false
      this.addUpdateVisible = true
    },
    // 编辑
    handleUpdate() {
      if (this.checkCurrentRowEmpty()) {
        this.$alert(this.$t("public.updateTips"), this.$t("public.tips"), {
          confirmButtonText: this.$t("public.define"),
        })
        return
      }
      this.isEdit = true
      this.addUpdateVisible = true
    },
    //新增成功
    addComplete(){
      this.listLoad()
    },
    //编辑成功
    updateComplete(){
        this.listLoad()
    },
    // 删除
    handleDelete() {
      if (this.checkCurrentRowEmpty()) {
        this.$alert(this.$t("public.deleteTips"), this.$t("public.tips"), {
          confirmButtonText: this.$t("public.define"),
        })
        return
      }
      const deleteData = {
        id: this.currentRow.terminalId,
      }
      this.$confirm(this.$t("public.deleteItemTips"), this.$t("public.tips"), {
        confirmButtonText: this.$t("public.define"),
        cancelButtonText: this.$t("public.cancel"),
        type: "warning",
      }).then(() => {
        deleteTermianlConfig(deleteData.id).then(({ data }) => {
          if (data.code === 0) {
            this.listLoad()
          }
        })
      })
    },
  },
}
</script>

<style scoped>
</style>